import { IApplicationState } from '../../types/redux';
import { IReliableHouseSchema } from '../../repositories/newbuilding-card/entities/house/ReliableHouseSchema';
import { pathOr } from 'ramda';

export function getReliableHouses(state: IApplicationState): string[] {
  return pathOr([], ['newbuilding', 'reliableHouses'], state);
}

export function getReliableHousesV2(state: IApplicationState): IReliableHouseSchema[] {
  return pathOr([], ['newbuilding', 'reliableHousesV2'], state);
}
